import { SlideshowFromDirection } from '@fukku/slideshow/types/Slideshow'
import { createStore } from 'zustand/vanilla'

export type IndexState = {
	index: number
}

export type IndexActions = {
	decrementIndex: () => void
	incrementIndex: () => void
	setIndex: (newIndex: number) => void
	rollIndex: (fromDirection: SlideshowFromDirection) => void
}

export type IndexStore = IndexState & IndexActions

export const defaultInitState: IndexState = {
	index: 0,
}

export const createIndexStore = (initState: IndexState = defaultInitState) =>
	createStore<IndexStore>()((set) => ({
		...initState,
		decrementIndex: () => set((state) => ({ index: state.index - 1 })),
		incrementIndex: () => set((state) => ({ index: state.index + 1 })),
		rollIndex: (fromDirection: SlideshowFromDirection) =>
			set((state) => ({
				index:
					fromDirection === SlideshowFromDirection.Left
						? state.index - 1
						: state.index + 1,
			})),
		setIndex: (newIndex: number) => set({ index: newIndex }),
	}))
